<template>
  <div
    class="calculator-container"
  >
    <div class="calculator-output">
      {{ currentValue }}
    </div>
    <button
      ref="topRowLeftButton"
      data-test="calculator-button-plus-minus"
      class="calculator-button calculator-button--top-row"
      @click="handleClick('+/-')"
    >
      +/-
    </button>
    <button
      data-test="calculator-button-percent"
      class="calculator-button calculator-button--top-row"
      @click="handleClick('%')"
    >
      %
    </button>
    <button
      data-test="calculator-button-square-root"
      class="calculator-button calculator-button--top-row"
      @click="handleClick('√')"
    >
      √
    </button>
    <button
      data-test="calculator-button-divide"
      class="calculator-button calculator-button--operator"
      :class="{ 'calculator-button--active': operator === '/' }"
      @click="handleClick('/')"
    >
      /
    </button>
    <button
      data-test="calculator-button-7"
      class="calculator-button"
      @click="handleClick('7')"
    >
      7
    </button>
    <button
      data-test="calculator-button-8"
      class="calculator-button"
      @click="handleClick('8')"
    >
      8
    </button>
    <button
      data-test="calculator-button-9"
      class="calculator-button"
      @click="handleClick('9')"
    >
      9
    </button>
    <button
      data-test="calculator-button-multiply"
      class="calculator-button calculator-button--operator"
      :class="{ 'calculator-button--active': operator === '*' }"
      @click="handleClick('*')"
    >
      *
    </button>
    <button
      data-test="calculator-button-4"
      class="calculator-button"
      @click="handleClick('4')"
    >
      4
    </button>
    <button
      data-test="calculator-button-5"
      class="calculator-button"
      @click="handleClick('5')"
    >
      5
    </button>
    <button
      data-test="calculator-button-6"
      class="calculator-button"
      @click="handleClick('6')"
    >
      6
    </button>
    <button
      data-test="calculator-button-minus"
      class="calculator-button calculator-button--operator"
      :class="{ 'calculator-button--active': operator === '-' }"
      @click="handleClick('-')"
    >
      -
    </button>
    <button
      data-test="calculator-button-1"
      class="calculator-button"
      @click="handleClick('1')"
    >
      1
    </button>
    <button
      data-test="calculator-button-2"
      class="calculator-button"
      @click="handleClick('2')"
    >
      2
    </button>
    <button
      data-test="calculator-button-3"
      class="calculator-button"
      @click="handleClick('3')"
    >
      3
    </button>
    <button
      data-test="calculator-button-plus"
      class="calculator-button calculator-button--operator"
      :class="{ 'calculator-button--active': operator === '+' }"
      @click="handleClick('+')"
    >
      +
    </button>
    <button
      data-test="calculator-button-clear"
      class="calculator-button calculator-button--top-row"
      @click="handleClick('AC')"
    >
      AC
    </button>
    <button
      data-test="calculator-button-0"
      class="calculator-button"
      @click="handleClick('0')"
    >
      0
    </button>
    <button
      data-test="calculator-button-decimal"
      class="calculator-button"
      @click="handleClick('.')"
    >
      .
    </button>
    <button
      data-test="calculator-button-equals"
      class="calculator-button calculator-button--operator"
      @click="handleClick('=')"
    >
      =
    </button>
  </div>
</template>

<script>
export default {
  props: {
    currentValue: {
      type: String,
      required: true,
    },
    operator: {
      type: String,
      required: false,
    },
  },
  mounted() {
    this.$refs.topRowLeftButton.focus();
  },
  methods: {
    handleClick(value) {
      this.$emit('button-click', value);
    },
  },
};
</script>

<style lang='scss' scoped>
.calculator-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(6, 3rem);
  grid-gap: 0.5rem;
  padding: 0.5rem;
  color: white;
  font-size: 1.2rem;
  font-weight: 600;
  border-radius: 0.5rem;
  width: 17rem;

  .calculator-output {
    grid-column: 1 / 5;
    grid-row: 1 / 2;
    background-color: #333;
    border-radius: 0.5rem;
    padding: 0.5rem;
    color: white;
    font-size: 1.5rem;
    text-align: right;
  }

  .calculator-button--double {
    grid-column: 1 / 3;
  }

  .calculator-button--top-row {
    background-color: hsl(205, 15%, 83%);
  }

  .calculator-button--operator {
    background-color: hsl(115, 15%, 83%);
  }

  .calculator-button--active {
    background-color: hsl(185, 98%, 40%);
  }
}
</style>
